import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// date and date-time formats in dayjs
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
export const DATE_TIME_FORMAT_SEC = "YYYY-MM-DD HH:mm:ss";

export function dateFormat(date?: string | Date) {
  return date ? dayjs(date).format(DATE_FORMAT) : "-";
}

export function dateTimeFormat(date?: string | Date): string {
  return date ? dayjs(date).format(DATE_TIME_FORMAT) : "-";
}

export function dateSecFormat(date?: string | Date) {
  return date ? dayjs(date).format(DATE_TIME_FORMAT_SEC) : "-";
}
